import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CursorFollower from "@/components/CursorFollower";
import AiChatbot from "@/components/AiChatbot";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import HelpCenter from "@/pages/HelpCenter";
import Manga from "@/pages/Manga";
import Demo from "@/pages/Demo";
import Signup from "@/pages/Signup";
import AdminSellers from "@/pages/AdminSellers";
import Abuse from "@/pages/Abuse";
import OptOut from "@/pages/OptOut";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CursorFollower />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/manga" element={<Manga />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/admin/sellers" element={<AdminSellers />} />
        <Route path="/abuse" element={<Abuse />} />
        <Route path="/report-abuse" element={<Abuse />} />
        <Route path="/opt-out" element={<OptOut />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <AiChatbot />
    </BrowserRouter>
  );
}
